module.exports = __webpack_public_path__ + "static/media/ball-joints.744eda12.svg";